export const compareVersions = (version1: string, version2: string): number => {
  if (!version1 || !version2) {
    return 0; // If either version is empty, return 0 (considered false)
  }
  const v1Parts = version1.split('.').map(Number);
  const v2Parts = version2.split('.').map(Number);

  const maxLength = Math.max(v1Parts.length, v2Parts.length);

  for (let i = 0; i < maxLength; i++) {
    const v1 = v1Parts[i] || 0;
    const v2 = v2Parts[i] || 0;

    if (v1 < v2) return -1;
    if (v1 > v2) return 1;
  }

  return 0;
};

export const checkValidExpiryTime = (
  expiryTimestampRaw: string | null,
  maxPastSeconds: number,
  maxFutureSeconds: number,
) => {
  if (!expiryTimestampRaw) return null;

  const value = Number(expiryTimestampRaw);

  if (!Number.isFinite(value)) return null;

  const MIN = Date.now() - maxPastSeconds * 1000;
  const MAX = Date.now() + maxFutureSeconds * 1000;

  if (value < MIN || value > MAX) return null;

  return value;
};

export const delay = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));
